import { styled } from '@mui/system';
import { ComponentPropsWithoutRef, ElementType } from 'react';

export type LogoButtonProps<T extends ElementType = 'button'> = {
  /**
   * What component to render this component as (inheriting props).
   * Useful when combining with e.g. react-router.
   */
  as?: T;
} & ComponentPropsWithoutRef<T>;

const LogoButtonRoot = styled('button', {
  name: 'AppBar',
  slot: 'LogoButton',
})(({ onClick }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  border: 'none',
  background: 'none',
  padding: 0,
  margin: 0,
  ...(onClick && { cursor: 'pointer', '& > *': { cursor: 'pointer' } }),
  '&:hover': {
    border: 'none',
    background: 'none',
  },
}));

const LogoButton = <T extends ElementType = 'button'>(props: LogoButtonProps<T>) => <LogoButtonRoot {...props} />;

LogoButton.displayName = 'AppBar.LogoButton';

export default LogoButton;
